import type { Patient } from '@pbt/pbt-ui-components'

import InvoiceType from '~/constants/InvoiceType'
import type { InvoiceOrEstimate } from '~/types'

/**
 * When creating an estimate, the template can be replaced by an invoice fetch (e.g. timetable
 * notifyAutochargedSoap). Refetch the estimate template in that case.
 */
export function shouldRefetchEstimateWhenWrongInvoiceTemplate(
  isEstimate: boolean,
  create: boolean | undefined,
  invoice: InvoiceOrEstimate,
  selectedPatient: Patient | null | undefined,
): boolean {
  return Boolean(
    isEstimate &&
    create &&
    invoice.type &&
    invoice.type !== InvoiceType.ESTIMATE &&
    selectedPatient,
  )
}

export function computeFetchInvoiceByEventId(args: {
  create?: boolean
  eventId?: string | null
  invoiceId?: string | null
  isFetching: boolean
  open: boolean
}): boolean {
  const { create, eventId, invoiceId, isFetching, open } = args
  return Boolean(!create && eventId && open && !invoiceId && !isFetching)
}
